<a [href]="url" class="social-link">
  <span class="social-link__icon">
    <un-icon [icon]="icon"></un-icon>
  </span>
</a>
